import React, { useState } from "react";
import styles from "./header.module.css";
import { experts } from "../../experts";
import { getRandomInt } from "../../../../util";

const Header = () => {
  const [randomExperts] = useState(
    [...experts].sort(() => 0.5 - Math.random()).slice(0, 3)
  );

  const [expertsOnline] = useState(getRandomInt(15, 20));

  return (
    <div className={styles.header}>
      <div>
        <h3 className={styles.title}>
          <span className={styles.title_italic}>The secrets</span> of your future finally revealed!
        </h3>
        <h3 className={styles.title}>Draw 3 cards from our <span className={styles.title_underline}>ASTRAL TAROT</span></h3>
      </div>
      <div className={styles.header_flex}>
        <div className={styles.images_flex}>
          {randomExperts.map((expert, idx) => (
            <img
              src={expert.avatar}
              className={styles.image}
              alt={expert.name}
            />
          ))}
        </div>
        <p className={styles.text}>
          {expertsOnline} verified experts are online now.
        </p>
      </div>
    </div>
  );
};

export { Header };
